module.exports = __webpack_public_path__ + "assets/assets/images/info/icon-doctors.837c9976.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/info/icon-doctors.svg
// module id = 221
// module chunks = 0